import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store, persistor } from './store';
import { PersistGate } from 'redux-persist/integration/react';
import { STORAGE, ACTIONS, APIS } from './_config';
import axios from 'axios'
import { Toaster } from "react-hot-toast";



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);



root.render(
  
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Toaster position="top-center" reverseOrder={false} />
      <App />
    </PersistGate>
  </Provider>
);


reportWebVitals();
